(() => {
  if (window.pqNewsletterReturnBound) return;
  window.pqNewsletterReturnBound = true;

  const params = new URLSearchParams(location.search);
  if (params.get('customer_posted') !== 'true') return;

  const storageKey = `pq-newsletter-landed:${location.pathname}`;
  const alreadyLanded = sessionStorage.getItem(storageKey) === '1';

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const cleanUrl = () => {
    params.delete('customer_posted');
    const query = params.toString();
    history.replaceState(null, '', location.pathname + (query ? `?${query}` : ''));
  };

  if (alreadyLanded) {
    window.scrollTo(0, 0);
    cleanUrl();
    return;
  }

  const land = () => {
    const form = document.querySelector('form[id^="ContactNewsletter-"]');
    if (form) form.scrollIntoView();
    sessionStorage.setItem(storageKey, '1');
    cleanUrl();
  };

  if (document.readyState === 'complete') {
    land();
  } else {
    window.addEventListener('load', land, { once: true });
  }
})();
